import { LoadingActions } from 'store/loadingModule/actions';
import React from 'react'; //eslint-disable-line

import loadable from 'loadable-components';
import Spinner from 'components/Spinner';

export default loadable(() => import('./containers/DailyBlockPageContainer'), {
  LoadingComponent: Spinner,
});

// export default store => ({
//   path: 'daily-block',
//   getComponent(nextState, cb) {
//     store.dispatch(LoadingActions.pageLoading('Daily Block Page'));
//     require.ensure(
//       [],
//       require => {
//         const container = require('./containers/DailyBlockPageContainer').default;
//         cb(null, container);
//         store.dispatch(LoadingActions.pageLoadingFinished());
//       },
//       'daily-block',
//     );
//   },
// });
